import React from "react";
import PropTypes from "prop-types";
import RightDrawer from "../RightDrawer";
import QuickAdd from "./QuickAdd";

const QuickAddDrawer = ({
  onUpdateQuickAddDrawerVisibility,
  drawerVisibility
}) => (
  <RightDrawer
    className="quick-add-drawer"
    onToggleDrawer={() => onUpdateQuickAddDrawerVisibility(false)}
    onCloseDrawer={() => onUpdateQuickAddDrawerVisibility(false)}
    getDrawerVisible={() => drawerVisibility}
    title="Quick Add"
  >
    <div className="md-grid">
      <div className="md-cell md-cell--12">
        <QuickAdd />
      </div>
    </div>
  </RightDrawer>
);

QuickAddDrawer.propTypes = {
  onUpdateQuickAddDrawerVisibility: PropTypes.func.isRequired,
  drawerVisibility: PropTypes.bool
};

export default QuickAddDrawer;



// WEBPACK FOOTER //
// ./src/staff/components/QuickAddDrawer/QuickAddDrawer.jsx